import { TableCell, TableRow, Tooltip, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { iconSize } from 'assets/theme/iconSize';
import { DefaultColumnResponse } from '../services/responses/default-columns.response';
import { useTranslation } from 'react-i18next';

interface Props {
    item: DefaultColumnResponse;
    onEdit: () => void;
    onDelete: () => void;
}

export function DefaultColumnRow({ item, onEdit, onDelete }: Props) {
    const { t } = useTranslation();
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: item.id,
    });

    return (
        <TableRow
            hover
            ref={setNodeRef}
            sx={{
                transform: CSS.Transform.toString(transform),
                transition,
                cursor: isDragging ? 'grabbing' : 'grab',
                opacity: isDragging ? 0.4 : 1,
            }}
            {...attributes}
            {...listeners}
        >
            <TableCell>{item.sortOrder + 1}</TableCell>
            <TableCell>{item.name}</TableCell>
            <TableCell>
                {/* Sem o stopPropagation um arrasto iniciado sobre o ícone viraria drag da linha. */}
                <div
                    style={{ display: 'flex', justifyContent: 'center' }}
                    onPointerDown={(e) => e.stopPropagation()}
                >
                    <Tooltip title={t('general.editar')}>
                        <IconButton size="small" sx={{ p: 0.25 }} onClick={onEdit}>
                            <EditIcon style={iconSize} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={t('general.excluir')}>
                        <IconButton size="small" sx={{ p: 0.25 }} onClick={onDelete}>
                            <DeleteIcon sx={iconSize} color="error" />
                        </IconButton>
                    </Tooltip>
                </div>
            </TableCell>
        </TableRow>
    );
}
